<style scoped lang="scss">
.online-order{
  position: fixed;
  top:60vh;
  right:0;
  background: #014492;
  color:#fff;
  z-index: 3;
  border-radius: 50px 0 0 50px;
  padding:10px 20px;
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  .icon-chart{
    margin-right: 15px;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .online-order{
    display: none!important;
  }
}
</style>
<template>
  <div class="online-order" @click="toBuy">
    <img src="@/assets/images/icon_chart_white.png" class="icon-chart">
    在线<br>订购
  </div>
</template>

<script>
export default {
  name: 'qk-online-order',
  methods: {
    toBuy () {
      this.$emit('order')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/onlineOrder.vue